/* global process */

export const SERVER_URL = process.env.REACT_APP_HTTP_LINK;
export const NODE_ENV = process.env.NODE_ENV;
export const INSTRUCTION_VIDEO_URL =
  process.env.REACT_APP_INSTRUCTION_VIDEO_URL;
